import * as Calendar from '../Calendar';
import { breakCases, clipCases } from '../SpecialCase';
import { extendDayJs } from '../extendDayJs';
extendDayJs();
export const normalizeSchedule = ({ dateFrom, dateTo, schedule, specialCases, }) => {
    // TODO: validation?
    const calendar = Calendar.fromSchedule({ schedule, dateFrom, dateTo });
    if (!specialCases) {
        return calendar;
    }
    const { open, closed } = breakCases(clipCases({ specialCases, dateFrom, dateTo }));
    const calendarWithOpenSpecialCases = Calendar.merge(calendar, Calendar.fromDayMap({ dayMap: open, dateFrom, dateTo }));
    return Calendar.subtract(calendarWithOpenSpecialCases, Calendar.fromDayMap({ dayMap: closed, dateFrom, dateTo }));
};
//# sourceMappingURL=normalizeSchedule.js.map